import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBriefing } from 'redux/briefing/briefingSlice';
import { setShift } from 'redux/briefing/shiftSlice';
import 'assets/scss/briefing.scss';
import 'assets/scss/driver-reservations.scss';
import { Toaster } from 'react-hot-toast';
import ActiveReservations from 'components/DriverReservations/activeReservations';
import ControlPanel from 'components/Briefing/oldBriefingControlPanel';

const DrivierReservations = () => {
    const briefing = useSelector((state) => state.briefing);
    const dispatch = useDispatch();

    const handleBriefingClick = (newBriefing) => {
        dispatch(setBriefing({
            ...briefing,
            line: newBriefing,
        }));
    };

    return (
        <>
            <Toaster position="bottom-right" />
            <div className="row warehouse-main-section-buttons-wrapper">
                <div className="col">
                    <button
                        onClick={() => handleBriefingClick('Briefings')}
                        className={`warehouse-main-header ${briefing.line === 'Briefings' ? "warehouse-active" : ""}`}
                    >
                        Active
                    </button>
                    <button
                        onClick={() => handleBriefingClick('Old Briefings')}
                        className={`warehouse-main-header ${briefing.line === 'Old Briefings' ? "warehouse-active" : ""}`}
                    >
                        Archives
                    </button>
                </div>
            </div>
            <div className="driver-reservations-content">
                {briefing.line === 'Old Briefings' && <ControlPanel />}
                <ActiveReservations />
            </div>
        </>
    );
};

export default DrivierReservations;
